import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import useCsvUpload from "../../hooks/useCsvUpload";
import Button from "../common/Button";
function ModalActions() {
  var _useCsvUpload = useCsvUpload(),
    _useCsvUpload2 = _slicedToArray(_useCsvUpload, 2),
    state = _useCsvUpload2[0],
    dispatch = _useCsvUpload2[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "py-5 border-t-[1px] border-gray-700"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "flex px-5 gap-5"
  }, /*#__PURE__*/React.createElement("li", {
    className: "ml-auto"
  }, /*#__PURE__*/React.createElement(Button, {
    isSecondary: true,
    className: "w-[156px]",
    onClick: function onClick() {
      dispatch({
        type: "reset"
      });
    }
  }, "Cancel")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Button, {
    isPrimary: true,
    className: "w-[156px]",
    onClick: function onClick() {
      dispatch({
        type: "upload"
      });
    }
  }, "Import"))));
}
export default ModalActions;